import type { RouteObject } from "react-router"

import { FeatureGuard } from "@/components/route/featureGuard/featureGuard"
import { RootPath } from "@/models/route"

import { FinancialOverview } from "./pages/financial-overview"

export const financialRoutes: RouteObject[] = [
  {
    path: RootPath.Financial,
    element: (
      <FeatureGuard feature="financial_overview">
        <FinancialOverview />
      </FeatureGuard>
    ),
  },
]
